import BusinessIcon from '@mui/icons-material/Business';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type PrivateCompanyTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * PrivateCompanyTile is a pre-configured EntityTypeTile for the Private Company entity type.
 *
 * @example
 * ```tsx
 * <PrivateCompanyTile
 *   selected={selectedType === 'private-company'}
 *   onClick={() => setSelectedType('private-company')}
 * />
 * ```
 */
const PrivateCompanyTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<PrivateCompanyTileProps>) => {
  return (
    <EntityTypeTile
      icon={<BusinessIcon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Private Company"
      description="A business with “Pty Ltd” in its name, owned by a small group of people. It can’t sell shares to the public."
      hint="Choose this if your business is a registered Pty Ltd company."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const PrivateCompanyTile = withClarityTheme(PrivateCompanyTileComponent);
